<template>
  <footer class="footer">
    <div class="has-text-centered footer__content">
      <ul class="is-flex is-justify-content-center">
        <li class="">
          <a href="https://twitter.com/intent/tweet?url=https://elkatsu.com&text=えるかつ！&via=elkatsu_info" rel="nofollow noopener" target="_blank"><img
              src="../assets/image/footer_icon_x.png"
              width="30"
              height="30"
              alt="twitter"
          /></a>
        </li>
        <li class="ml-3">
          <a href="http://www.facebook.com/share.php?u=https://elkatsu.com" rel="nofollow noopener" target="_blank">
            <img
              src="../assets/image/footer_icon_facebook.png"
              width="30"
              height="30"
              alt="facebook"
          /></a>
        </li>
        <li class="ml-3">
          <a href="http://line.me/R/msg/text/?https://elkatsu.com%0aえるかつ！" target="_blank" rel="nofollow noopener">
            <img
              src="../assets/image/footer_icon_line.png"
              width="30"
              height="30"
              alt="line"
          /></a>
        </li>
      </ul>
      <ul class="footer__menu">
        <li class="footer__menu__item">
          <router-link to="/user-policy">利用規約</router-link>
        </li>
        <li class="footer__menu__item">
          <router-link to="/privacy-policy">プライバシーポリシー</router-link>
        </li>
        <li class="footer__menu__item">
          <router-link to="/specific-trade-law"
            >特定商取引法に基づく表記</router-link
          >
        </li>
        <li class="footer__menu__item">
          <router-link to="/faq">FAQ</router-link>
        </li>
        <li class="footer__menu__item">
          <a href="https://forms.gle/eqNJLd7bLYmU1Crr7" target="_blank">お問い合わせ</a>
        </li>
      </ul>
      <p class="footer__copyright">©︎ 2024 えるかつ！</p>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer'
};
</script>

<style scoped></style>
